<template>
  <div>
    <bfheader></bfheader>
    <div class="main-content mt-2">
      <div class="header">
        <b-alert variant="info" :show="message != null">{{message}}</b-alert>
        <b-alert variant="danger" :show="error != null">{{error}}</b-alert>
      </div>
      <div class="container-fluid">
        <div class="p-2 border-bottom border-info">
          <h4 class="text-info font-italic">
            <strong>参加者一覧</strong>
            <span class="ml-5"><button class="btn btn-info" @click="loadItems"><i class="fas fa-sync"/> 再読込</button></span>
          </h4>
        </div>
        <div>
          <v-client-table :columns="table.columns" :data="users" :options="table.options" class="users-table">
            <a slot="user_id" slot-scope="props">
              <b-btn size="sm" variant="link" @click.prevent="onUserDisplay(props.row)"><b>{{props.row.user_id}}</b></b-btn>
            </a>
            <a slot="currentUserGroup.userNo" slot-scope="props">
              <b-link :href="linkToUserDailyEnquetes(props.row)" target="_blank"><b>{{ props.row.currentUserGroup.userNo }}</b></b-link>
            </a>
            <a slot="birthday" slot-scope="props">
              {{ formatBirthday(props.row.birthday) }}
            </a>
            <a slot="gender" slot-scope="props">
              {{ props.row.gender === '1' ? '男性' : '女性' }}
            </a>
            <a slot="physicalType" slot-scope="props">
              {{ props.row.physicalType === '2' ? 'アスリート' : '標準' }}
            </a>
            <a slot="enabled" slot-scope="props">
              {{ props.row.invalid ? '無効' : '有効' }}
            </a>
            <a slot="createdAt" slot-scope="props">
              {{ formatDateTime(props.row.createdAt) }}
            </a>
            <a slot="lastModifiedAt" slot-scope="props">
              {{ formatDateTime(props.row.lastModifiedAt) }}
            </a>
            <a slot="btns" slot-scope="props">
              <b-btn size="sm" variant="danger" @click="onDeleteConfirm(props.row.user)"><i class="fas fa-trash-alt"></i></b-btn>
            </a>
          </v-client-table>
        </div>
      </div>
    </div>

    <bffooter></bffooter>
    <div>
      <b-modal ref="deleteModal" title="削除確認" @ok="onDelete">
        <p>この参加者{{currentUser.user_id}}を削除しますか？</p>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { Logger } from 'aws-amplify'
import Vue from 'vue'
import moment from 'moment-timezone'
import { ClientTable } from 'vue-tables-2'

import bfheader from '@/components/BfHeader'
import bffooter from '@/components/BfFooter'

const logger = new Logger('UserSettings')
Vue.use(ClientTable)

export default {
  name: 'UserSettings',
  components: {
    bfheader,
    bffooter
  },
  data () {
    return {
      loading: false,
      message: null,
      error: null,
      users: this.$store.getters.users,
      currentUser: {},
      table: {
        columns: [
          'user_id', 'currentUserGroup.name', 'currentUserGroup.userNo',
          'age', 'birthday', 'gender', 'heightInCentimeters',
          'physicalType', 'weightAdjustmentInKilograms',
          'enabled', 'createdAt', 'lastModifiedAt', 'btns'
        ],
        options: {
          headings: {
            user_id: '会員番号',
            'currentUserGroup.userNo': 'ID番号',
            'currentUserGroup.name': '最新参加測定会',
            age: '年齢',
            birthday: '生年月',
            gender: '性別',
            heightInCentimeters: '身長',
            physicalType: '体型',
            weightAdjustmentInKilograms: '風量',
            enabled: '有効',
            userStatus: 'ステータス',
            registeredByGroupName: '登録時測定会',
            createdAt: '登録日時',
            lastModifiedAt: '更新日時',
            btns: '操作'
          },
          sortable: [ 'user_id', 'currentUserGroup.name', 'age', 'createdAt', 'lastModifiedAt' ],
          filterable: [ 'user_id', 'nickname' ],
          texts: {
            filterPlaceholder: '検索する'
          },
          sortIcon: {
            base: 'fas', up: 'fa-arrow-up', down: 'fa-arrow-down', is: 'fa-sort'
          },
          orderBy: {
            column: 'userNo',
            ascending: true
          }
        }
      }
    }
  },
  mounted: function () {
    this.loadItems()
  },
  methods: {
    formatDate (time) {
      return moment(time, 'x').format('YYYY/MM/DD HH:mm')
    },
    formatDateTime (time) {
      return moment(time, 'x').format('YYYY/MM/DD HH:mm:ss')
    },
    formatBirthday (date) {
      return moment(date, 'YYYY-MM-DD').format('YYYY/MM')
    },
    categoryName (categoryId) {
      return categoryId
    },
    open (id) {
      logger.debug('open', id)
    },
    edit (id) {
      logger.debug('hehogehogheo', id)
    },
    loadItems () {
      this.message = null
      this.error = null
      return new Promise((resolve) => {
        setTimeout(() => {
          return this.$store.dispatch('fetchUsers').then((users) => {
            logger.debug('found users:', users)
            this.users = users
          }).catch(err => {
            logger.error(err)
            this.error = err.message || err
          })
        }, 1000)
      })
    },
    refreshItems () {
      this.loadItems()
    },
    linkToUserDailyEnquetes (user) {
      return '/usergroups/' + user.currentUserGroup.groupId + '/users/' + user.user_id
    },
    onUserDisplay (user) {
      logger.debug('onUserDisplay:', user)
      this.$store.commit('setCurrentUser', { user })
      this.$router.push('/users/display')
    },
    onDeleteConfirm (user) {
      this.currentUser = user
      this.$refs.deleteModal.show()
    },
    onDelete () {
      this.loading = true
      this.message = null
      this.error = null
      this.user.currentUserGroups.forEach(ug => {
        return this.$store.dispatch('deleteUserDailyEnquetes', { userId: this.currentUser.user_id, groupId: ug.groupId })
      }).then(() => {
        return this.$store.dispatch('deleteUser', { userId: this.userId })
      }).then(() => {
        this.loading = false
        this.message = '削除しました'
        this.currentUser = {}
        this.refreshItems()
      }).catch((error) => {
        this.loading = false
        logger.error(error)
        this.error += error.message
      })
    }
  }
}
</script>

<style scoped>
.step-table, .users-table {
  font-size: 0.75rem;
}
</style>
